import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { useProfile } from 'context/profile';

/**
 * Returns true when the current user has access to more than one SNF group,
 * meaning the group name should be shown on discharge calendar patient cards.
 *
 * The discharge calendar only displays SNF patients, so other group types
 * (e.g. LTC) are excluded from the count.
 */
export default function useShowGroupName(): boolean {
  const { profile } = useProfile();

  if (profile.selectedGroups.length === 0) return true;

  const snfGroupCount = profile.selectedGroups.filter((g) => g.groupType === SKILLED_NURSING_FACILITY).length;

  return snfGroupCount > 1;
}
